import { api } from "./api";

export interface BRCoinTransacao {
  id: string;
  id_militar: string;
  tipo: "credito" | "debito";
  valor: number;
  descricao: string;
  criado_em: string;
}

export interface EmblemaLoja {
  id: string;
  emblema: string;
  img: string;
  descricao: string;
  valor: number;
  ordem: number;
  ja_possui: boolean;
  categoria?: {
    id: string;
    nome: string;
    ordem: number;
  } | null;
}

export const brcoinService = {
  async getSaldo(): Promise<{ brcoins: number }> {
    const response = await api.get("/brcoins/saldo");
    return response.data;
  },

  async getExtrato(): Promise<BRCoinTransacao[]> {
    const response = await api.get("/brcoins/extrato");
    return response.data;
  },

  async listarEmblemasLoja(): Promise<EmblemaLoja[]> {
    const response = await api.get("/loja/emblemas");
    return response.data;
  },

  async comprarEmblema(id: string): Promise<void> {
    await api.post(`/loja/emblemas/${id}/comprar`);
  },
};
